export default "__VITE_ASSET__CRstNwiM__"